export default function buildReimbursementQuery(rawS: any) {
  return {
    name: rawS._type,
    props: {
      title: rawS.title,
    },
  };
}
